import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';

const DOT_ANIMATION_DURATION_S = 2;
const ANIMATION_NAME = 'threeDotsAnimation';

const dot = (size, index) => ({
  height: size,
  width: size,
  borderRadius: '100%',
  backgroundColor: 'currentColor',
  animationName: ANIMATION_NAME,
  animationDuration: `${DOT_ANIMATION_DURATION_S}s`,
  animationIterationCount: 'infinite',
  animationFillMode: 'both',
  animationDelay: `${(DOT_ANIMATION_DURATION_S / 3) * index}s`,
});

const dotsMixin = (size, spacing) => ({
  span: {
    ...dot(size, 1),
    margin: `0 ${spacing}px`,
  },
  '&::before': {
    content: '" "',
    ...dot(size, 0),
  },
  '&::after': {
    content: '" "',
    ...dot(size, 2),
  },
});

export const useSpinnerStyles = createStyles(() => ({
  spinnerContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',

    '&.SpinnerContainer-square': {
      alignItems: 'center',

      // This is to make it square - padding percents are computed relative to parent's width
      '&::before': {
        content: '""',
        paddingTop: '100%',
      },
    },

    '&.SpinnerContainer-row': {
      alignItems: 'flex-start',
      height: 'auto',
    },

    '&.SpinnerContainer-overlay': {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      alignItems: 'center',
    },
  },

  threeDotsSpinner: {
    display: 'inline-flex',
    alignItems: 'flex-end',
    marginLeft: ThemeSpaces.SPACE_SM,

    '.three-dots-xs &, &.size-xs': dotsMixin(4, 2),
    '.three-dots-sm &, &.size-sm': dotsMixin(5, 4),
    '&, .three-dots-md &, &.size-md': dotsMixin(8, 6),
    '.three-dots-lg &, &.size-lg': dotsMixin(10, 8),

    [`@keyframes ${ANIMATION_NAME}`]: {
      '0%': { opacity: 0.2 },
      '50%': { opacity: 1 },
      '100%': { opacity: 0.2 },
    },
  },
}));
